"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrowserConfig = exports.getConfig = exports.init = exports.browserInit = void 0;
const config = {
    apiPublicKey: null,
    apiPrivateKey: null,
    baseUrl: null,
};
const browserConfig = {
    baseUrl: null,
};
/**
 * @deprecated use {@link TurnkeyClient} instead, which doesn't rely on global initialization logic.
 */
function browserInit(value) {
    browserConfig.baseUrl = assertNonEmptyString(value.baseUrl, "baseUrl");
}
exports.browserInit = browserInit;
/**
 * @deprecated use {@link TurnkeyClient} instead, which doesn't rely on global initialization logic.
 */
function init(value) {
    config.apiPublicKey = assertNonEmptyString(value.apiPublicKey, "apiPublicKey");
    config.apiPrivateKey = assertNonEmptyString(value.apiPrivateKey, "apiPrivateKey");
    config.baseUrl = assertNonEmptyString(value.baseUrl, "baseUrl");
}
exports.init = init;
function getConfig() {
    return {
        apiPublicKey: assertNonEmptyString(config.apiPublicKey, "apiPublicKey"),
        apiPrivateKey: assertNonEmptyString(config.apiPrivateKey, "apiPrivateKey"),
        baseUrl: assertNonEmptyString(config.baseUrl, "baseUrl"),
    };
}
exports.getConfig = getConfig;
function getBrowserConfig() {
    return {
        baseUrl: assertNonEmptyString(browserConfig.baseUrl, "baseUrl"),
    };
}
exports.getBrowserConfig = getBrowserConfig;
function assertNonEmptyString(input, name) {
    if (typeof input !== "string" || !input) {
        throw new Error(`"${name}" must be a non-empty string`);
    }
    return input;
}
//# sourceMappingURL=config.js.map